module.exports = __webpack_public_path__ + "static/media/play-questionnaire-icon.02246299.png";